import "./style.css";
import workshopImg from "../../resources/visednevne.jpg";
import singleImg from "../../resources/jednodnevne.jpg";
import beginnerImg from "../../resources/pocetnicke.jpg";
import onlineImg from "../../resources/banner.jpeg";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";

export const EducationsHomePage = () => {
    const navigate = useNavigate();
    const [isEducationUser, setIsEducationUser] = useState(false);

    useEffect(() => {
        const userType = localStorage.getItem("zajednica-user-type");
        setIsEducationUser(userType === "education");
    }, []);

    const phoneNumber = "+381 60-3859-426";
    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div className='page'>
            <div className='hero-wrapper'>
                <div className='header'>
                    <h1>Dobrodošli na</h1>
                    <h1>Masterclass</h1>
                    <h1>Barber Zajednice</h1>
                </div>
            </div>
            <div className='items'>
                <h1>Fokus na iskustvo i zajednicu</h1>
                <p>
                    Naše edukacije pružaju praktično iskustvo koje odmah možete
                    primeniti u radu, uz direktan uvid u tehnike profesionalnog
                    barbera.
                </p>
                <p>
                    Program je osmišljen da objedini teoriju kao i praksu kroz
                    demonstraciju i samostalan rad, kako bi se stečene veštine
                    mogle odmah primeniti u svakodnevnom radu.
                </p>
                <p>
                    U prijatnoj atmosferi, učite trikove i savete najboljih
                    barbera dok se istovremeno povezujete sa drugim
                    entuzijastima i razvijate svoju mrežu u industriji.
                </p>
                {isEducationUser && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginBottom: "20px",
                            animation: "fadeIn 3s ease-in-out",
                        }}
                    >
                        <p>
                            Prijavljeni ste kao edukator. Za upravljanje
                            edukacijama, posetite vaš profil.
                        </p>
                        <button
                            style={{
                                padding: "10px 20px",
                                backgroundColor: "#be9455",
                                border: "2px solid black",
                                borderRadius: "8px",
                                color: "white",
                                fontSize: "25px",
                                cursor: "pointer",
                                fontFamily: "Bebas Neue",
                                width: "200px",
                            }}
                            onClick={() => navigate("/profile")}
                        >
                            Moj Profil
                        </button>
                    </div>
                )}
                <h1>Višednevne edukacije</h1>
                <div
                    style={{
                        position: "relative",
                        display: "block",
                        animation: "fadeIn 3s ease-in-out",
                        width: "90%",
                        height: "400px",
                        margin: "0 auto",
                        marginTop: "-15px",
                    }}
                >
                    <img
                        src={workshopImg}
                        style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "15px",
                            border: "3px solid #be9455",
                            objectFit: "cover",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "99%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() => {
                            navigate("/educations/workshop");
                        }}
                    >
                        Prikaži više
                    </button>
                </div>
                <h1 style={{ marginTop: "50px", marginBottom: "-70px" }}>
                    Napredne
                </h1>
                <h1 style={{ marginTop: "50px", marginBottom: "-50px" }}>
                    Jednodnevene Edukacije
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "35px",
                        animation: "fadeIn 3s ease-in-out",
                    }}
                >
                    <img
                        src={singleImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "99%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() => navigate("/educations/single")}
                    >
                        Prikaži više
                    </button>
                </div>
                <h1 style={{ marginTop: "50px", marginBottom: "-50px" }}>
                    Početničke edukacije
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "30px",
                        animation: "fadeIn 3s ease-in-out",
                    }}
                >
                    <img
                        src={beginnerImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "99%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() => navigate("/educations/beginner")}
                    >
                        Prikaži više
                    </button>
                </div>
                <h1 style={{ marginTop: "50px", marginBottom: "-50px" }}>
                    On-line edukacije
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "30px",
                        marginBottom: "20px",
                        animation: "fadeIn 3s ease-in-out",
                    }}
                >
                    <img
                        src={onlineImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            opacity: "0.6",
                            border: "3px solid #be9455",
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#cccccc",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "#666",
                            fontSize: "25px",
                            cursor: "not-allowed",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                            textAlign: "center",
                        }}
                        title='Uskoro dostupno'
                    >
                        Uskoro...
                    </div>
                </div>
            </div>
            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
